import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Fontawesome from '../../fontawesome/fontawesome';
import { Link } from 'react-router-dom';
import './imageUpload.css';
import MUIDataTable from 'mui-datatables';
import { columns } from './columnsImageUpload';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useFetch } from '../../hooks/useFetch';
import { Prefix } from '../../../services/prefix';
import Dropzone from 'react-dropzone';
import { uniqueId } from 'lodash';
import api from '../../../services/api';
import { DropContainer, UploadMessage } from './uploadFile';
import Swal from 'sweetalert2';
import Loading from '../../loader/loading';
import { mutate as mutateGlobal } from 'swr';
import CustomSearchRender from '../../customSearchRender/CustomSearchRender';
import CustomFooter from '../../CustomFooter/CustomFooter';
import { ModalContainer } from "../../../style/stylesModals"; 

const UploadImage = ({ id, page, rowsPerPage, searchText }) => {
  const [show, setShow] = useState(false);
  const [uploaded, setUploaded] = useState([]);
  const [pagina, setPagina] = useState(0);
  const [perPage, setPerPage] = useState(15);
  const [search, setSearch] = useState('');
  const [nameAttach, setNameAttach] = useState();
  const [loader, setLoader] = useState(false);

  let pageExact = pagina + parseInt(1);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const listImages = useFetch(
    Prefix.replace(/[\\"]/g, '') +
      '/equipment-images?per_page=' +
      perPage +
      '&page=' +
      pageExact +
      '&search=' +
      search,
  );

  const HandleUpload = (files) => {
    setLoader(true);
    const uploadedFiles = files.map((file) => ({
      file,
      id: id,
      name: nameAttach,
      readableSize: file.size,
      path: URL.createObjectURL(file),
      progress: 0,
      uploaded: false,
      error: false,
      url: null,
    }));
    setUploaded({
      ...uploaded,
      uploadedFiles,
    });

    uploadedFiles.forEach(processUpload);
  };

  const processUpload = (uploadedFile) => {
    const data = new FormData();
    data.append('path', uploadedFile.file);
    data.append('name', uploadedFile.name);
    data.append('id_equipment_model', uploadedFile.id);
    api
      .post(Prefix.replace(/[\\"]/g, '') + '/equipment-images', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: 'Uow!',
          text: response.data.message,
          confirmButtonText: 'Fechar',
        }).then(() => {
          setLoader(false);
        });
        mutateGlobal(
          Prefix.replace(/[\\"]/g, '') +
            '/equipment-images?id_equipment_model=' +
            id,
        );
        listImages.mutate();
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: err.response.data.message,
          confirmButtonText: 'Tentar novamente',
        }).then(() => {
          setLoader(false);
        });
      });
  };

  function renderDragMessage(isDragActive, isDragReject) {
    if (!isDragActive) {
      return <UploadMessage>Arraste a imagem aqui</UploadMessage>;
    }
    if (isDragReject) {
      return <UploadMessage type="error">Arquivo não suportado</UploadMessage>;
    }

    return <UploadMessage type="success">Solte as imagens aqui</UploadMessage>;
  }

  function HandleDelete(e) {
    setLoader(true);
    let idArr = [];
    e.map((del) => {
      idArr.push(
        listImages.data?.models?.data.filter(
          (filtro, index) => index == del.index,
        )[0].id,
      );
    });

    idArr.map((idDel) =>
      api
        .delete(Prefix.replace(/[\\"]/g, '') + '/equipment-images/' + idDel)
        .then((response) => {
          Swal.fire({
            icon: 'success',
            title: 'Uow!',
            text: response.data.message,
            confirmButtonText: 'Fechar',
          }).then(() => {
            setLoader(false);
          });
          mutateGlobal(
            Prefix.replace(/[\\"]/g, '') +
              '/equipment-images?id_equipment_model=' +
              id,
          );
          listImages.mutate();
        })
        .catch((err) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: err.response.data.message,
            confirmButtonText: 'Tentar novamente',
          }).then(() => {
            setLoader(false);
          });
        }),
    );
  }

  const options = {
    draggableColumns: {
      enabled: true,
    },
    serverSide: true,
    onTableChange: (action, tableState) => {
      setPagina(tableState.page);
      setPerPage(tableState.rowsPerPage);
    },
    onSearchChange: (searchText) => {
      setSearch(!search ? '' : searchText);
    },
    customSearchRender: (searchText, handleSearch, hideSearch, options) => {
      return (
        <CustomSearchRender
          placeholderSearch="Pesquisar imagem"
          searchText={searchText}
          onSearch={handleSearch}
          onHide={hideSearch}
          options={options}
        />
      );
    },
    filter: false,
    page: pagina,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    rowsPerPage: perPage,
    rowsPerPageOptions: [15, 30, 100],

    onRowsDelete: (rowsDeleted, newData) => {
      HandleDelete(rowsDeleted.data);
    },
    searchPlaceholder: 'Pesquise uma imagem',
    selectableRows: 'multiple',
    searchOpen: true,

    textLabels: {
      body: {
        noMatch: 'Desculpe, não encontramos imagens!',
        toolTip: 'Sort',
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
      pagination: {
        next: 'Avançar',
        previous: 'Voltar',
        rowsPerPage: 'Linhas por página:',
        displayRows: 'de',
      },
      toolbar: {
        search: 'Pesquisar',
        downloadCsv: 'Baixar CSV',
        print: 'Imprimir',
        viewColumns: 'Ver Colunas',
        filterTable: 'Filtrar tabela',
      },
      filter: {
        all: 'Tudo',
        title: 'FILTROS',
        reset: 'RESETAR',
      },
      viewColumns: {
        title: 'Exibir colunas',
        titleAria: 'Exibir/Ocultar colunas da tabela',
      },
      selectedRows: {
        text: 'Coluna(s) selecionada(s)',
        delete: 'Excluir',
        deleteAria: 'Excluir linhas selecionadas',
      },
    },
    customFooter: (
      count,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage,
      textLabels,
    ) => {
      let numberPages = listImages.data?.models?.last_page;
      let rowsPerPageOptions = [15, 30, 100];
      return (
        <CustomFooter
          page={page}
          rowsPerPage={rowsPerPage}
          changeRowsPerPage={changeRowsPerPage}
          changePage={changePage}
          numberPages={numberPages}
          rowsPerPageOptions={rowsPerPageOptions}
        />
      );
    },
  };
  return (
    <>
      <Link className="dropdown-item" to="#" onClick={handleShow}>
        <Fontawesome classe="fas fa-images" />
      </Link>

      <ModalContainer 
        show={show}
        size="md"
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title><h3>Imagem de Modelo <br/>de Equipamento</h3></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loader && <Loading />}
          <div className="customerStep">
            <Row>
              <Col>
                <div className="formStep">
                  <label class="important">Nome da Imagem:</label>
                  <input
                    type="text"
                    name="name"
                    onBlur={(e) => setNameAttach(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="formStep">
                  <label class="important">Anexo:</label>
                  <Dropzone
                    maxFiles="1"
                    accept="application/pdf, image/*"
                    onDrop={(acceptedFiles) => HandleUpload(acceptedFiles)}
                  >
                    {({
                      getRootProps,
                      getInputProps,
                      isDragActive,
                      isDragReject,
                    }) => (
                      <DropContainer
                        {...getRootProps()}
                        isDragActive={isDragActive}
                        isDragReject={isDragReject}
                      >
                        <input {...getInputProps()} />
                        {renderDragMessage(isDragActive, isDragReject)}
                      </DropContainer>
                    )}
                  </Dropzone>
                </div>
              </Col>
            </Row>
          </div>

          <MUIDataTable
            title={'Lista de Imagens de Modelos'}
            data={listImages.data?.models?.data.filter(
              (filtro) => filtro.equipment_model.id == id,
            )}
            columns={columns}
            options={options}
          />
        </Modal.Body>
      </ModalContainer >
    </>
  );
};
export default UploadImage;
